/* import __COLOCATED_TEMPLATE__ from './refer-a-friend.hbs'; */
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { closeModal } from "sh-www/utils/modal-controls";

/** @module */
const ReferAFriendModal = Component.extend({
  tagName: '',

  /** @type {Ember.Service} */
  assignmentCommandService : service('commands/assignment-commands'),

  /** @type {Ember.Service} */
  applicationStateManager: service('state-managers/application'),

  /** @inheritDoc */
  actions: {
    /**
     * @param {string} name
     * @param {string} email
     * @return {Promise<*>}
     */
    submit(name, email) {
      return this.get('assignmentCommandService').refer(this.get('model.assignment'), name, email).then(() => {
        this.get('applicationStateManager').addToast('Email sent.');
        closeModal(this);
      });
    },

    /**
     *
     */
    close() {
      closeModal(this);
    },
  },
});

export default ReferAFriendModal;
